module.exports = __webpack_public_path__ + "img/apple-app-store.bae7ab53.png";